import React from 'react';
import { SolutionProjects } from '../../layouts/SolutionProjects';

const Page = (location) => <SolutionProjects {...location} />;
export default Page;
